var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"icon":_vm.params.props.icon,"size":"small"},on:{"click":function($event){return _vm.params.props.action(_vm.params.data)}}},[_vm._v(_vm._s(_vm.params.props.label))])}
var staticRenderFns = []

export { render, staticRenderFns }